import { render } from "./user-customer-report.vue?vue&type=template&id=3b2ee3da&scoped=true"
import script from "./user-customer-report.vue?vue&type=script&lang=js"
export * from "./user-customer-report.vue?vue&type=script&lang=js"

import "./user-customer-report.vue?vue&type=style&index=0&id=3b2ee3da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2ee3da"]])

export default __exports__